/* global goog */
/* global Blockly */
import { AppType } from '../../utils';

const fieldWidgetsDropdown = function () {
    Blockly.FieldWidgetsDropdown = function (context, opt_widgetTypes, opt_validator, opt_show_select, opt_on_change, parentFormId) {
        if (typeof menuGenerator === "function") {
            throw new TypeError("FieldWidgetsDropdown cannot have function for menu generator (for now)");
        }

        const filter = function(w){
            if (!!parentFormId && w.formId !== parentFormId) {
                // doesn't belong to specified form
                return false;
            }
            if(typeof opt_widgetTypes === 'function'){
                return opt_widgetTypes(w);
            } else if(Array.isArray(opt_widgetTypes)){
                return opt_widgetTypes.includes(w.type);
            } else if ((typeof opt_widgetTypes) === 'string'){
                return opt_widgetTypes === w.type
            } else {
                return true
            }
        }

        // get widgets according to widget types
        let widgets = context.pages.map(function(page){           
            return page.widgets.filter(filter);
        });

        if (context.appTypeId === AppType.LOCKDOWN && !!context.sliderChildren) {
            const sliderChildWidgets = context.sliderChildren.map(function (sliderChild) {
                return sliderChild.widgets.filter(filter);
            });
            widgets = widgets.concat(sliderChildWidgets);        
        }
        widgets = widgets.reduce(function(acc,x){return acc.concat(x)},[]);


        // Sort according first to what page they appear on, then by the widget name
        widgets = widgets.sort(function(a, b) {
            const pageA = Blockly.FieldWidgetsDropdown.displayPageName(a.page).toLowerCase();
            const pageB = Blockly.FieldWidgetsDropdown.displayPageName(b.page).toLowerCase();
            if( pageA > pageB) {
                return 1;
            } else if (pageA < pageB) {
                return -1;
            } else{
                return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
            }
        });

        // trim page names
        widgets = widgets.map(function(x){
            const page = {
                display:Blockly.FieldWidgetsDropdown.trimmedPageName(x.page,30),
                name:Blockly.FieldWidgetsDropdown.displayPageName(x.page)
            }
            return [x.name,x.id,page];
        });

        if (widgets.length<1){
            widgets = [['< no widgets >', '', {display:'',name:''}]]
            this.warnNoWidgets = true;
        }

        Blockly.FieldWidgetsDropdown.superClass_.constructor.call(this, widgets, opt_validator, opt_show_select, opt_on_change);

        // Insert separators for new pages
        const finalOpts = [];
        for (const opt of widgets) {
            if (!finalOpts.some(function(x) { return Blockly.FieldWidgetsDropdown.displayPageName(x[2])=== opt[2].name })) {
                finalOpts.push([opt[2],"_SEPARATOR_", opt[2]])
            }
            finalOpts.push(opt);
        }
        this.menuGenerator_ = finalOpts;

        const closure = this.init
        this.init = function(){
            if (this.warnNoWidgets){
                this.sourceBlock_.setWarningText("This block refers to a Snap widget that does not exist, please modify or remove");
            }
            closure.bind(this)()
        }.bind(this);
    };

    goog.inherits(Blockly.FieldWidgetsDropdown, Blockly.FieldDropdownSearch);

    // Force field re-render to correct any size miscalculation from XML loading interference
    Blockly.FieldWidgetsDropdown.prototype.onLoad = function() {
        if (this.sourceBlock_?.rendered && this.textElement_) {
            this.render_();
        }
    };

    Blockly.FieldWidgetsDropdown.displayPageName = function (page){
        if(page.formName){
            return page.formName + " > " + page.name
        }
        return page.name
    }

    Blockly.FieldWidgetsDropdown.trim = function(str, len){
        if(str.length<=len) return str;
        const halfLen = Math.floor(len/2);
        return str.substring(0,halfLen-2)+"..."+str.substring(str.length-halfLen-1,str.length);
    }

    Blockly.FieldWidgetsDropdown.trimmedPageName = function (page, length){
        const halfLen = Math.floor(length/2);
        if(page.formName){
            const formName = Blockly.FieldWidgetsDropdown.trim(page.formName, halfLen-2);
            const pageName = Blockly.FieldWidgetsDropdown.trim(page.name, halfLen-1)

            return formName + " > " + pageName;
        }
        return Blockly.FieldWidgetsDropdown.trim(page.name, halfLen);
    }





    /**
     * Resize the editor to fit the text.
     * @protected
     */
    Blockly.FieldWidgetsDropdown.prototype.resizeEditor_ = function () {
        const scale = this.sourceBlock_.workspace.scale;
        const div = Blockly.WidgetDiv.DIV;

        let initialWidth;
        if (this.sourceBlock_.isShadow() || this.getTotalFields_() == 1) {
            initialWidth = this.sourceBlock_.getHeightWidth().width * scale;
        } else {
            initialWidth = this.size_.width * scale;
        }

        let width;
        if (Blockly.BlockSvg.FIELD_TEXTINPUT_EXPAND_PAST_TRUNCATION) {
            // Resize the box based on the measured width of the text, pre-truncation
            let textWidth = Blockly.pxtBlocklyUtils.measureText(
                Blockly.FieldTextInput.htmlInput_.style.fontSize,
                Blockly.FieldTextInput.htmlInput_.style.fontFamily,
                Blockly.FieldTextInput.htmlInput_.style.fontWeight,
                Blockly.FieldTextInput.htmlInput_.value
            );
            // Size drawn in the canvas needs padding and scaling
            textWidth += Blockly.FieldTextInput.TEXT_MEASURE_PADDING_MAGIC;
            textWidth *= scale;
            width = textWidth;
        } else {
            // Set width to (truncated) block size.
            width = initialWidth;
        }
        // The width must be at least FIELD_WIDTH and at most FIELD_WIDTH_MAX_EDIT
        width = Math.max(width, Blockly.BlockSvg.FIELD_WIDTH_MIN_EDIT * scale);
        width = Math.min(width, Blockly.BlockSvg.FIELD_WIDTH_MAX_EDIT * scale);

        const inputHeight = this.getTotalFields_() == 1 ?
            this.sourceBlock_.getHeightWidth().height : Blockly.BlockSvg.FIELD_HEIGHT_MAX_EDIT;

        // Add 1px to width and height to account for border (pre-scale)
        div.style.width = (width / scale + 1) + 'px';
        div.style.height = (inputHeight + 1) + 'px';
        div.style.transform = 'scale(' + scale + ')';

        // Use margin-left to animate repositioning of the box (value is unscaled).
        // This is the difference between the default position and the positioning
        // after growing the box.
        div.style.marginLeft = -0.5 * (width - initialWidth) + 'px';

        // Add 0.5px to account for slight difference between SVG and CSS border
        const borderRadius = this.getBorderRadius() + 0.5;
        div.style.borderRadius = borderRadius + 'px';
        //Blockly.FieldTextInput.htmlInput_.style.borderRadius = borderRadius + 'px';
        // Pull stroke colour from the existing shadow block
        const strokeColour = this.sourceBlock_.getColourTertiary();
        div.style.borderColor = strokeColour;

        const xy = this.getAbsoluteXY_();
        // Account for border width, post-scale
        xy.x -= scale / 2;
        xy.y -= scale / 2;
        // In RTL mode block fields and LTR input fields the left edge moves,
        // whereas the right edge is fixed.  Reposition the editor.
        if (this.sourceBlock_.RTL) {
            xy.x += width;
            xy.x -= div.offsetWidth * scale;
            xy.x += 1 * scale;
        }
        // Shift by a few pixels to line up exactly.
        xy.y += 1 * scale;
        if (Blockly.utils.userAgent.GECKO && Blockly.WidgetDiv.DIV.style.top) {
            // Firefox mis-reports the location of the border by a pixel
            // once the WidgetDiv is moved into position.
            xy.x += 2 * scale;
            xy.y += 1 * scale;
        }
        if (Blockly.utils.userAgent.WEBKIT) {
            xy.y -= 1 * scale;
        }
        // Finally, set the actual style
        div.style.left = xy.x + 'px';
        div.style.top = xy.y + 'px';
    };


    Blockly.FieldWidgetsDropdown.prototype.getBorderRadius = function () {
        if (this.sourceBlock_.getOutputShape() == Blockly.OUTPUT_SHAPE_ROUND) {
            return Blockly.BlockSvg.NUMBER_FIELD_CORNER_RADIUS;
        }
        return Blockly.BlockSvg.TEXT_FIELD_CORNER_RADIUS;
    };

    Blockly.FieldWidgetsDropdown.prototype.createTextInput_ = function () {

        const htmlInput = document.createElement('input');
        htmlInput.className = 'blocklyHtmlInput';
        let txt = this.menuGenerator_.find(function(x){
            return x[1] == this.value_
        }.bind(this));

        if(!this.hasBeenSet) {
            txt = this.selectOption_;
        } else if(txt !==undefined && txt[0] !== undefined){
            txt = txt[0];
        } else {
            txt = '< no widgets >'
        }
        htmlInput.setAttribute('placeholder', txt);

        htmlInput.style.fontSize = Blockly.BlockSvg.FIELD_TEXTINPUT_FONTSIZE_FINAL + 'pt';

        htmlInput.addEventListener('keydown', (e) => {
            if (e.key.toLowerCase() === 'enter') {
                const filtered = this.menu_.children_.filter(function (item) {
                    return !(item instanceof goog.ui.MenuHeader) && item.fullContent_.toLowerCase().startsWith(e.target.value.toLowerCase())
                });
                if (filtered.length === 1) {
                    this.onItemSelected(this.menu_, filtered[0]);
                    Blockly.FieldWidgetsDropdown.cleanUpEditor();
                }
            } else if (e.key.toLowerCase() === "escape") {
                Blockly.Events.setGroup(false);
            }
        });

        htmlInput.addEventListener('input', (e) => {
            if (this.menu_) {
                const menu = this.menu_;
                const filteredItems = [];
                const headers = [];
                menu.children_.forEach(function (item) {
                    if(item instanceof goog.ui.MenuHeader){
                        headers.push(item);
                        return;
                    }

                    if (item.fullContent_.toLowerCase().startsWith(e.target.value.toLowerCase())) {
                        filteredItems.push(item);
                        item.removeClassName('displayNone');
                    } else {
                        item.addClassName('displayNone');
                    }
                });

                const remainingCategories = new Set(filteredItems.map(function(x){return x.category}));
                headers.forEach(function(header){
                    if(remainingCategories.has(header.getContent())){
                        header.removeClassName('displayNone');
                    } else {
                        header.addClassName('displayNone');
                    }
                })

                const notFoundItem = menu.children_[menu.children_.length - 1];
                if (filteredItems.length === 0) {
                    notFoundItem.removeClassName('displayNone')
                } else {
                    notFoundItem.addClassName('displayNone');
                }
            }
        });

        return htmlInput;
    }

    Blockly.FieldWidgetsDropdown.cleanUpEditor = function(){
        Blockly.DropDownDiv.hide();
        Blockly.WidgetDiv.hide();
        Blockly.Events.setGroup(false);
    }

    Blockly.FieldWidgetsDropdown.prototype.populateMenu_ = function (options) {
        for (const option of options) {
            let content = option[0]; // Human-readable text or image.
            const value = option[1]; // Language-neutral value.
            const page = option[2];
            const separator = value === '_SEPARATOR_';
            if (separator) {
                let menuItem = new goog.ui.MenuHeader(content.display);

                menuItem.setRightToLeft(this.sourceBlock_.RTL);
                this.menu_.addChild(menuItem, true);
                menuItem.getElement().style.borderColor = this.sourceBlock_.getColourTertiary();
                if(content.name!=content.display){
                    let tooltip = new goog.ui.Tooltip(undefined, content.name);
                    tooltip.attach(menuItem.element_)
                }
                continue;
            }
            if (typeof content == 'object') {
                // An image, not text.
                const image = new Image(content['width'], content['height']);
                image.src = content['src'];
                image.alt = content['alt'] || '';
                content = image;
            }
            const trimmedContent = Blockly.FieldWidgetsDropdown.trim(content,30);

            const menuItem = new goog.ui.MenuItem(trimmedContent);
            menuItem.setRightToLeft(this.sourceBlock_.RTL);
            menuItem.setValue(value);
            menuItem.fullContent_ = content;
            menuItem.setCheckable(true);
            menuItem.category = page.name;
            this.menu_.addChild(menuItem, true);
            const checked = (value == this.value_);
            menuItem.setChecked(checked);
            if (checked) {
                this.selectedItem = menuItem;
            }

            if(trimmedContent != content){
                let tooltip = new goog.ui.Tooltip(undefined, content);
                tooltip.attach(menuItem.element_)
            }
        }
    };

    Blockly.FieldWidgetsDropdown.prototype.showEditor_ = function () {
        Blockly.WidgetDiv.show(this, this.sourceBlock_.RTL);

        this.textInput_ = this.createTextInput_();

        const div = Blockly.WidgetDiv.DIV;
        div.classList.add('fieldTextInput');
        div.appendChild(this.textInput_);
        this.resizeEditor_();

        const options = this.getOptions();
        if (options.length == 0) return;

        this.dropDownOpen_ = true;
        // If there is an existing drop-down someone else owns, hide it immediately and clear it.
        Blockly.DropDownDiv.hideWithoutAnimation();
        Blockly.DropDownDiv.clearContent();

        const contentDiv = Blockly.DropDownDiv.getContentDiv();

        let selected = false;

        const callback = (e) => {
            if (selected) return;
            const menuItem = e.target;
            if (menuItem) {
                this.onItemSelected(this.menu_, menuItem);
                selected = true;
            }
            Blockly.FieldWidgetsDropdown.cleanUpEditor();
        };

        this.menu_ = new goog.ui.Menu();
        this.menu_.setRightToLeft(this.sourceBlock_.RTL);
        this.populateMenu_(options);
        const notFoundItem = new goog.ui.MenuItem("not found");
        notFoundItem.fullContent_ = "not found";
        notFoundItem.setRightToLeft(this.sourceBlock_.RTL);
        notFoundItem.setValue(null);
        notFoundItem.setCheckable(false);
        notFoundItem.setEnabled(false);
        notFoundItem.addClassName('displayNone');

        this.menu_.addChild(notFoundItem, true);

        // Listen for mouse/keyboard events.
        goog.events.listen(this.menu_, goog.ui.Component.EventType.ACTION, callback);

        // Record windowSize and scrollOffset before adding menu.
        this.menu_.render(contentDiv);
        const menuDom = this.menu_.getElement();
        Blockly.utils.dom.addClass(menuDom, 'blocklyDropdownMenu');
        // Record menuSize after adding menu.
        const menuSize = Blockly.utils.uiMenu.getSize(this.menu_);
        // Recalculate height for the total content, not only box height.
        menuSize.height = menuDom.scrollHeight;

        const primaryColour = (this.sourceBlock_.isShadow()) ?
            this.sourceBlock_.parentBlock_.getColour() : this.sourceBlock_.getColour();

        Blockly.DropDownDiv.setColour(primaryColour, this.sourceBlock_.getColourTertiary());

        const category = (this.sourceBlock_.isShadow()) ?
            this.sourceBlock_.parentBlock_.getCategory() : this.sourceBlock_.getCategory();
        Blockly.DropDownDiv.setCategory(category);

        Blockly.DropDownDiv.showPositionedByField(this, this.onHide.bind(this));

        this.menu_.setAllowAutoFocus(false);

        // Update colour to look selected.
        if (!this.disableColourChange_) {
            if (this.sourceBlock_.isShadow()) {
                this.sourceBlock_.setShadowColour(this.sourceBlock_.getColourTertiary());
            } else if (this.box_) {
                this.box_.setAttribute('fill', this.sourceBlock_.getColourTertiary());
            }
        }
        this.textInput_.focus();
    };

}

export default fieldWidgetsDropdown
